import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../campaigns/assets/images/application-success.svg'
import _imports_1 from '../../campaigns/assets/images/app-reject.png'


const _withScopeId = n => (_pushScopeId("data-v-53840642"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-d-flex p-justify-center w-100" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "p-mt-6" }, "Accepted successfully")
], -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-d-flex p-flex-column p-align-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "image-action" }, [
    /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "action-status" }, "You successfully accepted the request!"),
  /*#__PURE__*/_createElementVNode("p", null, "We’ll notify the brand, so you can get paid for your content.")
], -1))
const _hoisted_3 = { class: "p-d-flex p-justify-center" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-d-flex p-justify-center w-100" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "p-mt-6" }, "Request rejected")
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-d-flex p-flex-column p-align-center" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("img", { src: _imports_1 })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "action-status" }, "You successfully rejected the request!"),
  /*#__PURE__*/_createElementVNode("p", null, "We’ll send you more content requests in the future."),
  /*#__PURE__*/_createElementVNode("p")
], -1))
const _hoisted_6 = { class: "p-d-flex p-justify-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_ContentRequestModal = _resolveComponent("ContentRequestModal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Dialog, {
      header: "",
      visible: $props.action === 'accept',
      style: { width: '30vw' },
      modal: true
    }, {
      header: _withCtx(() => [
        _hoisted_1
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_Button, {
            label: "OK",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('closeActions'))),
            class: "red-button btn"
          })
        ])
      ]),
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_Dialog, {
      visible: $props.action === 'reject',
      style: {width: '30vw'},
      modal: true
    }, {
      header: _withCtx(() => [
        _hoisted_4
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_Button, {
            label: "OK",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('closeActions'))),
            class: "red-button btn"
          })
        ])
      ]),
      default: _withCtx(() => [
        _hoisted_5
      ]),
      _: 1
    }, 8, ["visible"]),
    ($props.action === 'counter')
      ? (_openBlock(), _createBlock(_component_ContentRequestModal, {
          key: 0,
          show: $props.action === 'counter' ? true : false,
          "counter-offer": true,
          item: $props.item,
          onCounterOffer: $setup.counterOffer
        }, null, 8, ["show", "item", "onCounterOffer"]))
      : _createCommentVNode("", true)
  ]))
}